import React, { useState } from "react";
import "./professionals.css";
import NarrowInputField from "../../components/input/new/narrowInputField";
import NarrowDropdown2 from "../../components/input/new/narrowDropdown2";
import { useDispatch, useSelector } from "react-redux";
import { authenticatedFetch } from "../../network/api";
import BackIcon from "./assets/backIcon.png";

const AddProfessionalForm = ({ onCancel, onSave }) => {
  const profileTypes = [
    { label: "Legal Professionals", value: "legal" },
    { label: "Practice Support Specialists", value: "support" },
  ];
  const dispatch = useDispatch();
  const firmDetails = useSelector((state) => state.firm.details); // Get firm details from Redux
  const [professionalType, setProfessionalType] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");

  const [lastName, setLastName] = useState("");

  const [firstName, setFirstName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  // State to handle loading and error messages
  const [isInviting, setIsInviting] = useState(false);
  const [inviteError, setInviteError] = useState(null);
  const [inviteSuccess, setInviteSuccess] = useState(null);

  const isValidEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  // Function to handle invite
  const handleSubmit = async () => {
    // Reset any previous messages
    setInviteError(null);
    setInviteSuccess(null);

    // Basic front-end validation
    if (!email || !isValidEmail(email) || email !== confirmEmail) {
      setInviteError("Invalid or missing email.");
      return;
    }
    if (!firstName) {
      setInviteError("Name is required.");
      return;
    }
    if (!lastName) {
      setInviteError("Name is required.");
      return;
    }
    if (!professionalType) {
      setInviteError("Please select a professional type.");
      return;
    }

    // Ensure firmDetails is available
    if (!firmDetails) {
      setInviteError(
        "Firm details are missing. Please ensure firm information is loaded."
      );
      return;
    }

    setIsInviting(true); // Start loading

    try {
      // Prepare the metadata
      const metadata = {
        firm_id: firmDetails.id,
        firm_name: firmDetails.name,
        firm_website: firmDetails.firm_website_url,
        firm_onboarding: firmDetails.stripe_onboarding_status,
        // Add more firm-related details as needed
      };

      console.log("Firm Details --- ", firmDetails);
      console.log("Metadata --- ", metadata);

      const response = await authenticatedFetch("/api/attorney/webapp/inviteProfessional", {
        method: "POST",
        body: JSON.stringify({
          email,
          role: professionalType,
          firstName,
          lastName,
          phoneNumber,
          metadata,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle any server or validation errors
        console.error("Invite error:", data.error);
        setInviteError(`Invite failed: ${data.error}`);
        return;
      }

      // If successful
      console.log("Invite successful:", data);
      setInviteSuccess("Invitation sent successfully!");

      // Optionally, reset the form
      setEmail("");
      setFirstName("");
      setLastName("");
      setConfirmEmail("");
      setProfessionalType("");
      onSave();

      // Optionally, navigate to another page
      // navigate('/some-other-page'); // Uncomment if needed
    } catch (error) {
      console.error("Error inviting professional:", error);
      setInviteError(
        "An unexpected error occurred while sending the invitation."
      );
    } finally {
      setIsInviting(false); // End loading
    }
  };

  return (
    <div className="add-professional-form">
      <button className="appt-back-link" onClick={onCancel}>
        <img
          src={BackIcon}
          alt="Back"
          style={{
            height: "20px",
            width: "20px",
            marginRight: "8px",
          }}
        />
        Back to list
      </button>
      <h2 className="professionals-primary-title">New Legal professional</h2>

      {/* Basic info */}
      <h3 className="professionals-secondary-title">Basic information</h3>

      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <NarrowInputField
          name="First Name"
          title="First Name"
          placeholder="Enter professional's first name"
          isRequired={true}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          halfWidth={true}
        />

        <NarrowInputField
          name="Last Name"
          title="Last Name"
          placeholder="Enter professional's last name"
          isRequired={true}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          halfWidth={true}
        />
      </div>

      <div className="divider" />

      {/* Role */}
      <h3 className="professionals-secondary-title">Role</h3>
      <NarrowDropdown2
        title="Select profile type"
        placeholder="Select one"
        items={profileTypes}
        isRequired={true}
        value={professionalType}
        onChange={(e) => setProfessionalType(e)}
        multiple={false}
        halfWidth={false}
      />
      <div className="divider" />

      {/* Account login */}
      <h3 className="professionals-secondary-title">Account login</h3>
      <p className="professionals-subtext">
        Once you enter an email address, a verification link will be sent. The
        recipient must click the link to complete password setup.
      </p>

      <NarrowInputField
        name="Email Address"
        title="Email Address"
        placeholder="Enter email"
        isRequired={true}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        halfWidth={false}
      />

      <NarrowInputField
        name="Confirm Email Address"
        title="Confirm Email Address"
        placeholder="Enter email"
        isRequired={true}
        value={confirmEmail}
        onChange={(e) => setConfirmEmail(e.target.value)}
        halfWidth={false}
      />

      <NarrowInputField
        name="Phone Number"
        title="Phone Number"
        placeholder="Enter phone number"
        isRequired={false}
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        halfWidth={false}
      />

      {inviteError && <div className="error-message">{inviteError}</div>}
      {inviteSuccess && <div className="success-message">{inviteSuccess}</div>}

      <div style={{ height: "3rem" }} />

      <hr className="h-rule" />

      <div className="form-actions">
        <p className="need-help-text"> Need Help?</p>
        <button className="save-button" onClick={handleSubmit}>
          Save
        </button>
      </div>
    </div>
  );
};

export default AddProfessionalForm;
